import React, { useState, useEffect, useRef } from "react";
import "./registrationfrom.css";
// import FormInputs from "./FormInputs";
import FormInputs from '../../Components/Shared/FormInputs/FormInputs'
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import searchIcon from "../../Assets/Images/EployeeRegistration/search-icon.png";
import EndPoints from "../../Api/Endpoints";

function Address({ setAddress }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [stateName, setStateName] = useState("");
  const searchContainerRef = useRef(null);
  const [searchPermCity, setSearchPermCity] = useState("");
  const [filteredPermCity, setFilteredPermCity] = useState([]);
  const [selectedPermCity, setSelectedPermCity] = useState(null);
  const [stateNamePerm, setStateNamePermPerm] = useState("");
  const searchPermCityRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    loc_add1: "",
    loc_add2: "",
    loc_city_id: 0,
    loc_pincode: "",
    prim_mob_no: "",
    sec_mob_no: "",
    per_email_id: "",
    perm_add1: "",
    perm_add2: "",
    perm_city_id: 0,
    perm_pincode: "",
  });

  const [sameAsLocal, setSameAsLocal] = useState(false);

  setAddress(values);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    setAddress((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  // Event handler for the checkbox
  const handleCheckboxChange = (event) => {
    setSameAsLocal(event.target.checked);
    if (event.target.checked) {
      // Copy local address values to permanent address
      setValues({
        ...values,
        perm_add1: values.loc_add1,
        perm_add2: values.loc_add2,
        perm_pincode: values.loc_pincode,
        perm_city_id: values.loc_city_id,
        // Add other fields you want to copy from local address to permanent address
      });
      setSearchPermCity(searchTerm);
      setStateNamePermPerm(stateName);
    } else {
      // Clear permanent address values
      setValues({
        ...values,
        perm_add1: "",
        perm_add2: "",
        perm_pincode: "",
        perm_city_id: "",
        // Add other fields you want to clear for permanent address
      });
      setSearchPermCity("");
      setStateNamePermPerm("");
    }
  };
  // console.log("Local City ID:", searchTerm);
  // const handleItemClickOne = (item) => {
  //   setSelectedCity(item);
  //   setSearchTerm(`${item.city_name}`);
  //   setStateName(item.state_name);
  //   setFilteredCity([]);
  //   setAddress((prevInfo) => ({
  //     ...prevInfo,
  //     loc_city_id: item.city_id,
  //   }));
  // };

  const handleItemClickOne = (item) => {
    setSelectedCity(item);
    setSearchTerm(`${item.city_name}`);
    setStateName(item.state_name);
    setFilteredCity([]);

    // Update loc_city_id in values state
    setValues((prevValues) => ({
      ...prevValues,
      loc_city_id: item.city_id,
    }));

    // Update the parent component's data
    setAddress((prevInfo) => ({
      ...prevInfo,
      loc_city_id: item.city_id,
    }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // const handleSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);
  //   if (value.trim() === "" || value.length < 3) {
  //     setFilteredCity([]);
  //     setSelectedCity(null);
  //     setStateName("");
  //   }
  // };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilteredCity([]);
      setSelectedCity(null);
      setStateName("");
    } else if (value.length >= 3) {
      handleSearchClick();
    }
  };

  useEffect(() => {
    console.log("Search term:", searchTerm);
  }, [searchTerm]);

  // const handleSearchClick = () => {
  //   // console.log("Search term:", searchTerm);
  //   if (searchTerm.trim() === "" || searchTerm.length <= 2) {
  //     setFilteredCity([]);
  //     return;
  //   }
  //   fetch(
  //     `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
  //       searchTerm
  //     )}`
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       const filtered = data.filter((item) =>
  //         Object.values(item).some(
  //           (val) =>
  //             typeof val === "string" &&
  //             val.toLowerCase().includes(searchTerm.toLowerCase())
  //         )
  //       );
  //       setFilteredCity(filtered);
  //     })
  //     .catch((error) => {
  //       console.error("There was a problem with your fetch operation:", error);
  //     });
  // };

  const handleSearchClick = () => {
    console.log("Search term:", searchTerm);
    if (searchTerm.trim() === "" || searchTerm.length < 2) {
      setFilteredCity([]);
      return;
    }

    // Using callback function to ensure the latest value of searchTerm is used
    setSearchTerm((prevSearchTerm) => {
      fetch(
        `${EndPoints.PRISM_GET_CITY_LIST_SEARCH_KEY}?search_key=${encodeURIComponent(
          prevSearchTerm // Using prevSearchTerm which ensures the latest value
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("other")}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchTerm.toLowerCase())
            )
          );
          setFilteredCity(filtered);
        })
        .catch((error) => {
          console.error(
            "There was a problem with your fetch operation:",
            error
          );
        });

      // Returning prevSearchTerm to maintain the existing state
      return prevSearchTerm;
    });
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setFilteredCity([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // API CALL FOR PERMANANT CITY
  const handleSearchChangePermCity = (e) => {
    const value = e.target.value;
    setSearchPermCity(value);
    if (value.trim() === "") {
      setFilteredPermCity([]);
      setSelectedPermCity(null);
      setStateNamePermPerm("");
    } else if (value.length >= 3) {
      handleSearchClickPermCity();
    }
  };

  // const handleSearchClickPermCity = () => {
  //   if (searchPermCity.trim() === "" || searchTerm.length < 2) {
  //     setFilteredPermCity([]);
  //     return;
  //   }
  //   fetch(
  //     `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
  //       searchPermCity
  //     )}`
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       const filtered = data.filter((item) =>
  //         Object.values(item).some(
  //           (val) =>
  //             typeof val === "string" &&
  //             val.toLowerCase().includes(searchPermCity.toLowerCase())
  //         )
  //       );
  //       setFilteredPermCity(filtered);
  //     })
  //     .catch((error) => {
  //       console.error("There was a problem with your fetch operation:", error);
  //     });
  // };

  const handleSearchClickPermCity = () => {
    if (searchPermCity.trim() === "" || searchPermCity.length < 2) {
      setFilteredPermCity([]);
      return;
    }
    // Using callback function to ensure the latest value of searchPermCity is used
    setSearchPermCity((prevSearchPermCity) => {
      fetch(
        `${EndPoints.PRISM_GET_CITY_LIST_SEARCH_KEY}?search_key=${encodeURIComponent(
          prevSearchPermCity // Using prevSearchPermCity which ensures the latest value
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("other")}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchPermCity.toLowerCase())
            )
          );
          setFilteredPermCity(filtered);
        })
        .catch((error) => {
          console.error(
            "There was a problem with your fetch operation:",
            error
          );
        });

      // Returning prevSearchPermCity to maintain the existing state
      return prevSearchPermCity;
    });
  };

  const handleItemClickPermCity = (item) => {
    setSelectedPermCity(item);
    setSearchPermCity(`${item.city_name}`);
    setStateNamePermPerm(item.state_name);
    setFilteredPermCity([]);

    // Update perm_city_id in values state
    setValues((prevValues) => ({
      ...prevValues,
      perm_city_id: item.city_id,
    }));

    // Update the parent component's data
    setAddress((prevInfo) => ({
      ...prevInfo,
      perm_city_id: item.city_id,
    }));
  };

  const handleClickOutsidePerm = (event) => {
    if (
      searchPermCityRef.current &&
      !searchPermCityRef.current.contains(event.target)
    ) {
      setFilteredPermCity([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePerm);
    return () => {
      document.removeEventListener("click", handleClickOutsidePerm);
    };
  }, []);

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>Addresses</h2>
          <img src={EditIcon} alt="icon"/>
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <div className="address-info">
            <div>
              <FormInputs
                label="Local Address"
                type="text"
                name="loc_add1"
                value={values.loc_add1}
                onChange={onChange}
                placeholder="Address line 1"
                maxlength="200"
                pattern="[A-Za-z0-9-, ]{1,200}"
                required
              />
            </div>
            <div>
              <FormInputs
                type="text"
                name="loc_add2"
                value={values.loc_add2}
                onChange={onChange}
                placeholder="Address line 2"
                maxlength="200"
                pattern="[A-Za-z0-9-, ]{1,200}"
              />
            </div>
            <div className="grid-container-address">
              <div className="search-form">
                <label>
                  City<span className="city-required">*</span>
                </label>
                <div className="search-icon" ref={searchContainerRef}>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      style={{ paddingRight: "30px" }}
                    />
                    <span className="search-button" onClick={handleSearchClick}>
                      <img src={searchIcon} alt="search" />
                    </span>
                  </div>
                  {/* <input
                    type="text"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  /> */}
                  {/* <span className="search-button" onClick={handleSearchClick}>
                    <FaSearch />
                  </span> */}
                  {filteredCity.length > 0 && (
                    <div className="filter-search-items">
                      {filteredCity.map((item, index) => (
                        <div
                          key={index}
                          className="filter-items"
                          onClick={() => handleItemClickOne(item)}
                        >
                          <p>{`${item.city_name}`}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <FormInputs
                  label="State"
                  type="text"
                  value={stateName}
                  disabled={selectedCity !== null}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Pin Code"
                  type="text"
                  name="loc_pincode"
                  value={values.loc_pincode}
                  onChange={onChange}
                  maxLength={6}
                  pattern="[0-9]{6}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Primary Mobile Number"
                  type="text"
                  name="prim_mob_no"
                  value={values.prim_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  required
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Secondary Mobile Number"
                  type="text"
                  name="sec_mob_no"
                  value={values.sec_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Personal Email Id "
                  type="email"
                  name="per_email_id"
                  value={values.per_email_id}
                  onChange={onChange}
                  maxLength={150}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{{2,}}"
                />
              </div>
            </div>
            <div className="parmanent-add-checkbox">
              <div style={{ position: "relative" }}>
                <div className="local-add-checkbox">
                  <label>Same as Local Address</label>
                  <input
                    type="checkbox"
                    checked={sameAsLocal}
                    onChange={handleCheckboxChange}
                    className="cr-custom-checkbox"
                  />
                </div>
                <FormInputs
                  label="Permanent Address"
                  type="text"
                  name="perm_add1"
                  value={values.perm_add1}
                  onChange={onChange}
                  placeholder="Address line 1"
                  disabled={sameAsLocal}
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  required
                />
                <FormInputs
                  type="text"
                  name="perm_add2"
                  value={values.perm_add2}
                  onChange={onChange}
                  placeholder="Address line 2"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  disabled={sameAsLocal}
                />
              </div>
              <div className="grid-container-address">
                <div className="search-form">
                  <label>
                    City<span className="city-required">*</span>
                  </label>
                  <div className="search-icon" ref={searchPermCityRef}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchPermCity}
                        onChange={handleSearchChangePermCity}
                        style={{ paddingRight: "30px" }}
                      />
                      <span
                        className="search-button"
                        onClick={handleSearchClickPermCity}
                      >
                        <img src={searchIcon} alt="search" />
                      </span>
                    </div>
                    {filteredPermCity.length > 0 && (
                      <div className="filter-search-items">
                        {filteredPermCity.map((item, index) => (
                          <div
                            key={index}
                            className="filter-items"
                            onClick={() => handleItemClickPermCity(item)}
                          >
                            <p>{`${item.city_name}`}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="State"
                    type="text"
                    value={stateNamePerm}
                    disabled={selectedPermCity !== null}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="Pin Code"
                    type="text"
                    name="perm_pincode"
                    value={values.perm_pincode}
                    onChange={onChange}
                    maxLength={6}
                    pattern="[0-9]{6}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Address;